// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage, defineMessages } from "react-intl";

export const LensCtaTextLabel = (props: { text: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lensCta.components.lensCtaTextLabel"
        description="Lens cta text label."
        defaultMessage="Text: {text}"
        values={props}
    />
);
LensCtaTextLabel.displayName = "LensCtaTextLabel";

export const LensCtaWebsiteLabel = (props: { url: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lensCta.components.lensCtaWebsiteLabel"
        description="Lens cta website label."
        defaultMessage="Website: {url}"
        values={props}
    />
);
LensCtaWebsiteLabel.displayName = "LensCtaWebsiteLabel";

export const LensCtaDeeplinkLink = (props: { uri: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lensCta.components.lensCtaDeeplinkLink"
        description="Lens cta deeplink link."
        defaultMessage="Deeplink: {uri}"
        values={props}
    />
);
LensCtaDeeplinkLink.displayName = "LensCtaDeeplinkLink";

export const messages = defineMessages({
    lensCtaEditLabel: {
        id: "apps.lensCta.components.lensCtaEditLabel",
        description: "Lens cta edit label.",
        defaultMessage: "Edit {label}",
    },
    lensCtaAddLabel: {
        id: "apps.lensCta.components.lensCtaAddLabel",
        description: "Lens cta add label.",
        defaultMessage: "Add {label}",
    },
});
